import { render, staticRenderFns } from "./set_approval_status_modal.vue?vue&type=template&id=f2907470&"
import script from "./set_approval_status_modal.vue?vue&type=script&lang=js&"
export * from "./set_approval_status_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "set_approval_status_modal.vue"
export default component.exports